import { TRideShiftTimeCheckSkippedByAllowOverride } from "../../constants/rides.const";
import { Log } from "../log.helpers";

export interface ILogShiftTimeCheckSkippedByAllowOverrideArguments {
  checkKey: TRideShiftTimeCheckSkippedByAllowOverride;
  message: string;
}

export const logShiftTimeCheckSkippedByAllowOverride = ({
  checkKey,
  message,
}: ILogShiftTimeCheckSkippedByAllowOverrideArguments): void => {
  Log.info(
    `ℹ️ ${message} — shift time check "${checkKey}" skipped due to allowShiftTimeOverrideDuringManualAction setting`,
  );
};
